<template>
    <div class="wrapper" id="app">
        <topbar />
        <the-header />
        <main class="main">
            <div class="container">
                <router-view></router-view>
            </div>
        </main>
        <the-footer />
        <cookie-notification />
        <seller-modal/>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { Component } from 'vue-property-decorator';
    import CookieNotification from '@/components/cookies/CookieNotification';
    import TheFooter from '@/components/general/TheFooter';
    import TheHeader from '@/components/general/TheHeader';
    import Topbar from '@/components/general/Topbar';
    import SellerModal from './components/modals/SellerModal';
    import {LOCALE_LOAD} from './store/modules/locale';

    @Component({
        components: {
            SellerModal,
            CookieNotification,
            TheFooter,
            TheHeader,
            Topbar
        }
    })
    export default class App extends Vue {
        name = 'app';

        created() {
            this.$store.dispatch(LOCALE_LOAD);
        }
    }
</script>

<!-- Import SCSS boilerplate -->
<style src="./assets/css/styles.scss" lang="scss"></style>




// WEBPACK FOOTER //
// src/App.vue